import type { User } from '../models/api.model';
import { BOOKING_ACTION_ACCESS, canAccess } from './access-control';

export function canModifyBooking(user: User | null, hasPayments: boolean): boolean {
  return canAccess(user, BOOKING_ACTION_ACCESS.manage) && (user?.role.level === 1 || !hasPayments);
}
